<template>
  <div class="main-content">
    <question-radio-button-group :questionTypes="questionTypes" :orderId="reqOrderId" @selectQueType="selectQueType"> </question-radio-button-group>
      <!-- <z-button-group>
        <z-button @click="confirmSubmit" :disabled="!canSubmit" type="primary" size="large">提交</z-button>
      </z-button-group> -->
  </div>
</template>

<script>
import QuestionRadioButtonGroup from '../question-radio-button-group'
import { isZlj } from '../../../../lib/utils'
import { getQuestionList } from '@api/resourceApi'

// 数组转换成树的方法
function arrayToTree(
  casList,
  formatItemFn = (item) => ({
    ...item,
    title: item.name,
    value: item.id,
    key: item.id,
    disabled: false
  }),
  sortFn
) {
  let data = [...casList]
  data = data.map(formatItemFn)
  data.forEach((item) => {
    const { parId, parentId } = item
    if (parId !== '0') {
      data.forEach((distItem) => {
        if (distItem.id === parId || distItem.id === parentId) {
          distItem.children = distItem.children ? [...distItem.children, item] : [item]
        }
      })
      if (sortFn) {
        data.sort(sortFn)
      }
    }
  })
  data = data.filter((item) => item.level !== '3')
  return data
}

export default {
  name: 'QuestionSelectList',
  components: {
    QuestionRadioButtonGroup
  },
  data() {
    return {
      // 弹窗显示隐藏
      popupVisible: false,
      // 选中的问题
      selectedQuestionType: '',
      // 问题数组
      questionTypes: [],
      // 请求的订单ID
      reqOrderId: '',
      // 是否能提交
      canSubmit: false,
      // 选择的问题详情
      selectTypeVal: {},
      // APP种类
      clientType: isZlj() ? 2 : 1
    }
  },
  watch: {
    orderId(curvalue, _newval) {
      // this.fetchState()
      console.log('问题分类的orderId发生了变化', curvalue)
    },
    orderItem(curvalue, _newval) {
      // this.fetchState()
      console.log('问题分类的orderItem发生了变化', curvalue)
      this.fetchState()
    }
  },
  props: {
    // questionTypes: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // 订单ID
    orderId: {
      type: String,
      default: ''
    },
    // 订单详情
    orderItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created() {
    this.fetchState()
  },
  methods: {
    // 获取问题分类的方法
    async fetchState(_params) {
      console.log('问题分类的props', this.orderId, this.orderItem)
      // this.reqOrderId = this.orderId
      // this.questionTypes = []
      const { infoId = '', businessType = '' } = this.orderItem
      let res
      if (infoId && businessType && this.orderId) {
        // 调用接口
        res = await getQuestionList({
          clientType: this.clientType,
          orderId: this.orderId,
          businessType
        })
        console.log('res is what', res)
      } else {
        res = await getQuestionList({
          clientType: this.clientType
        })
        console.log('res is what', res)
      }
      // 解析出数组，c2cSpecialFaqInfo为C2C是特殊的C2C类问题
      const { c2cSpecialFaqInfo, questionTypeList = [], tradeType = '' } = res
      // fakeDliverFaq为虚假发货的问题ID
      const { c2cSpecialFaqList = [], fakeDliverFaq = '' } = c2cSpecialFaqInfo || {}
      // 提取问题分类中级别大于1的问题
      let questionTypes = questionTypeList.filter(item => {
        const { level } = item
        if (level && Number(level) > 1) {
          return true
        } else {
          return false
        }
      })
      // 遍历哪个为虚假发货的问题，哪些又是其他的C2C类特殊的问题
      questionTypes = questionTypes.map(item => {
        const { faqId = '' } = item
        const isOtherC2CSpecialFaq = faqId && c2cSpecialFaqList.length && c2cSpecialFaqList.indexOf(faqId) > -1 && faqId !== fakeDliverFaq ? 1 : 0
        const isC2CFakeDliverFaq = fakeDliverFaq && faqId && faqId === fakeDliverFaq ? 1 : 0
        return {
          ...item,
          isOtherC2CSpecialFaq,
          isC2CFakeDliverFaq,
          tradeType,
          id: faqId
        }
      })
      console.log('questionTypes 222', questionTypes)
      // 将数组转换为树
      questionTypes = arrayToTree(questionTypes)
      console.log('questionTypes 333', questionTypes)
      this.questionTypes = questionTypes
    },
    // 选中的问题触发的回调
    selectQueType(typeVal) {
      console.log('typeVal', typeVal)
      // if (typeVal) {
      this.selectTypeVal = typeVal
      this.confirmSubmit()
      // this.canSubmit = true
      // }
    },
    // 触发上层回调
    confirmSubmit() {
      console.log('send')
      this.$emit('onQuestionTypeChange', this.selectTypeVal)
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('handleCloseQuestionList')
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>